import { environment } from 'src/environments/environment';
import { ReportFormInterface } from 'src/types';

export const CTMS_DOCUMENT_MISSING_WARNING =
  'CTMS/LNG Quantity Report is missing. Upload the document used for the reported cargo quantity and LNG composition values.';

export const CTMS_DOCUMENT_UPLOAD_TOOLTIP =
  'Upload the CTMS/LNG Quantity Report. If it is not available yet, submit the report and upload the document later.';

export const isCtmsDocumentApplicable = (
  report: Pick<ReportFormInterface, 'reportType' | 'portActivity'>,
  shouldCollectLngN2Inputs: boolean,
) => {
  const cargoActivity = report.portActivity === 'loading' || report.portActivity === 'discharging';
  return shouldCollectLngN2Inputs && report.reportType === 'cast_off' && cargoActivity;
};

export const hasCtmsDocument = (
  report: Pick<ReportFormInterface, 'ctmsDocumentUuid' | 'ctmsDocumentId' | 'ctmsDocumentName'>,
) => !!(report.ctmsDocumentUuid || report.ctmsDocumentId || report.ctmsDocumentName);

export const shouldShowCtmsDocumentWarning = (
  report: Pick<
    ReportFormInterface,
    'created' | 'reportType' | 'portActivity' | 'ctmsDocumentUuid' | 'ctmsDocumentId' | 'ctmsDocumentName'
  >,
  shouldCollectLngN2Inputs: boolean,
) => {
  return isCtmsDocumentWarningEligible(report, shouldCollectLngN2Inputs) && !hasCtmsDocument(report);
};

export const isCtmsDocumentWarningEligible = (
  report: Pick<ReportFormInterface, 'created' | 'reportType' | 'portActivity'>,
  shouldCollectLngN2Inputs: boolean,
) => {
  const created = Date.parse(report.created || '');
  const effectiveAt = Date.parse(environment.ctmsDocumentWarningEffectiveAt);
  return (
    Number.isFinite(created) &&
    Number.isFinite(effectiveAt) &&
    created >= effectiveAt &&
    isCtmsDocumentApplicable(report, shouldCollectLngN2Inputs)
  );
};
